// ============================================================================
// DamagePreviewPanel.jsx
// ============================================================================

import React from 'react';
import { Target, Shield, Skull, Zap, Sword } from 'lucide-react';

const DamagePreviewPanel = ({ title, heroName, damageData = [] }) => {
    if (!damageData || damageData.length === 0) return null;

    return (
        <div style={{
            background: "rgba(0, 0, 0, 0.8)",
            backdropFilter: "blur(10px)",
            borderRadius: "12px",
            border: "1px solid rgba(255,16,38,0.2)",
            padding: "16px",
            marginTop: "10px"
        }}>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                paddingBottom: "8px"
            }}>
                <div style={{ fontWeight: "bold", color: "#ffd7dc", display: "flex", alignItems: "center", gap: 8 }}>
                    <Target size={16} />
                    {title || "Damage Estimate"}
                </div>
                <div style={{ fontSize: "12px", color: "#6b7280" }}>vs Target Def</div>
            </div>

            <div style={{ display: "grid", gap: "8px" }}>
                {damageData.map((item, idx) => (
                    <div key={idx} style={{
                        display: "grid",
                        gridTemplateColumns: "1fr auto auto",
                        alignItems: "center",
                        gap: "12px",
                        padding: "8px",
                        background: "rgba(255, 255, 255, 0.03)",
                        borderRadius: "8px"
                    }}>
                        {/* Skill Name & Type */}
                        <div>
                            <div style={{ fontWeight: "bold", fontSize: "13px", color: item.color || "#fff" }}>
                                {item.skillName}
                            </div>
                            <div style={{ fontSize: "11px", color: "#9ca3af", display: "flex", gap: "6px" }}>
                                <span>RAW: {item.rawDamage?.toLocaleString()}</span>
                                {item.damageType === 'Physical' && <span style={{ color: "#ef4444" }}>(Phys)</span>}
                                {item.damageType === 'Magic' && <span style={{ color: "#8b5cf6" }}>(Mag)</span>}
                                {item.damageType === 'True' && <span style={{ color: "#fff" }}>(True)</span>}
                            </div>
                        </div>

                        {/* Net Damage */}
                        <div style={{ textAlign: "right" }}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: item.netDamage > 0 ? "#22c55e" : "#6b7280",
                                fontFamily: "monospace"
                            }}>
                                {item.netDamage?.toLocaleString()}
                            </div>
                            <div style={{ fontSize: "10px", color: "#ef4444" }}>
                                {item.reductionPct > 0 ? `-${item.reductionPct}% Blocked` : 'True Dmg (0% Blocked)'}
                            </div>
                        </div>

                        {/* Health Cut % */}
                        <div style={{
                            minWidth: "60px",
                            textAlign: "right",
                            borderLeft: "1px solid rgba(255,255,255,0.1)",
                            paddingLeft: "12px"
                        }}>
                            <div style={{ fontWeight: "bold", fontSize: "14px", color: "#ff1026" }}>
                                {item.hpCutPct}%
                            </div>
                            <div style={{ fontSize: "10px", color: "#9ca3af" }}>HP Cut</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DamagePreviewPanel;
